import React, {Component} from "react";
import {connect} from 'react-redux';
import {message} from 'antd';
import GridReference from "../../../custom_libs/heatmap_overlay";
import {Button, Divider, Grid, Typography} from "@mui/material";
import {morphleBaseTheme1} from "../themes";
import {mapSlideToProps} from "../../../redux_reducers/utils";
import {get_response} from "../../../helper/request";

class IndxApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:{},
            showGrid: false,
        }
        this.gridRef = null;
    }

    componentDidMount = () => {
	    let url = `/api/get_indx_data/?id=${this.props.slide.id}`
        get_response(url).then(res => {
            this.setState({
                data: res.data['data'],
                gridColor: "#FFFFFF",
                gridSize: 256,
                gridWidth: 3,
            })
        })
    }

    componentWillUnmount() {
        if (this.gridRef) {
	        this.props.slidemap.removeControl(this.gridRef);
        }
    }

    drawGrid = () => {
	    if (this.gridRef) {
		    this.props.slidemap.removeControl(this.gridRef);
	    }

	    var extent = this.props.slidemap.getView().getProjection().getExtent();
	    var height = this.props.slide.stitched_y_max * this.props.slide.stitched_tile_height;
	    var width = this.props.slide.stitched_x_max * this.props.slide.stitched_tile_width;
	    var gridEveryU = this.state.gridSize;
	    var gridCols = width / gridEveryU;
	    var gridRows = height / gridEveryU;

	    this.gridRef = new GridReference(
		    {
			    extent: extent,
			    size: [gridCols, gridRows],
			    target: document.querySelector(".options div"),
			    property: "commune",
			    color: '#' + this.state.gridColor,
			    width: this.state.gridWidth,
			    heatmapData: this.state.data,
		    }
	    );

	    this.props.slidemap.addControl(this.gridRef);
    }

    gridSwitch = () => {
        console.log("state_data", this.state.data)
        if(Object.keys(this.state.data).length == 0){
            message.error("Data not available")
            return;
        }
        this.setState({
            showGrid: !this.state.showGrid,
        })
    }

    render() {
        if (this.state.showGrid) {
            this.drawGrid();
        } else if (this.gridRef) {
	        this.props.slidemap.removeControl(this.gridRef);
        }
        let isEmpty = Object.keys(this.state.data).length === 0;
        return <Grid>
                    <Typography variant={"h3"} sx={{color: morphleBaseTheme1.palette.text.primary}}>Indx.AI</Typography>
                    <Divider/>
                    <Grid >
                            <Button variant={"contained"} color={"secondary"} onClick={this.gridSwitch} disabled={isEmpty} sx={{marginTop :'2.5vh', marginLeft:"20%"}}>
                                {this.state.showGrid?"Hide Heatmap":isEmpty?"Data Unavailable":"Show Heatmap"}
                            </Button>
                    </Grid>
                </Grid>
    }
}

export default connect(mapSlideToProps)(IndxApp);


